export enum SupportAgentToolName {
  CANCEL_ORDER = "cancel-order",
  CONTACT_SUPPORT = "contact-support",
  COMPARE_PRODUCTS = "compare-products",
  CREATE_BUNDLE = "create-bundle",
  CREATE_DISCOUNT_CODE = "create-discount-code",
  CURRENT_VIEWED_PRODUCT = "current-viewed-product",
  GENERATE_PRODUCT_VISUALIZATION = "generate-product-visualization",
  GET_RECENT_ORDERS = "get-recent-orders",
  GIFT_CARD_BALANCE = "gift-card-balance",
  HANDOFF_TO_HUMAN = "handoff-to-human",
  HANDOFF_DETECTION = "handoff-detection",
  LOOKUP_ORDER = "lookup-order",
  LOOKUP_PRODUCTS = "lookup-products",
  ORDER_TRACKING = "order-tracking",
  RESEND_GIFT_CARD = "resend-gift-card",
  RESEND_RETURN_LABEL = "resend-return-label",
  RETRIEVE_SUPPORT_KNOWLEDGE = "retrieve-support-knowledge",
  RETURN_STATUS = "return-status",
  SUBSCRIBE_TO_BACK_IN_STOCK = "subscribe-to-back-in-stock",
  UPDATE_ORDER_SHIPPING_ADDRESS = "update-order-shipping-address",
  UPDATE_ORDER = "update-order",
  WISHLIST = "wishlist",
  GET_CART = "get-cart",
  GET_PRODUCT_DETAILS = "get-product-details",
  SEARCH_STORE_CATALOG = "search-store-catalog",
  STORE_POLICIES_AND_FAQ = "store-policies-and-faq",
  UPDATE_CART = "update-cart",
}

export const SUPPORT_AGENT_TOOL_NAMES = Object.values(SupportAgentToolName);

/**
 * Converts a support agent tool name to a user-friendly display name
 */
export function supportAgentToolNameToDisplayName(toolName: string): string {
  return toolName
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
